import { useaxios } from "../../../utils/useaxios";
export default (text) => initDispatch => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('item/read.php', { text }).then((res) => {
        if (res == "auth_failed") {
            alert('no internet connection');
            return false;
        }
        if (res.status == "ok") {
            initDispatch({ type: 'setitem', payload: res.data });
        }
        // setloading(false);
    });
}